import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import ModalBase1 from "./modal_base_1.tsx";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../config.ts";
import { ViewBase1Form } from "../views/view_base_1.tsx";

export default function ModalGebaeudetyp() {
    const push_modal_non_close = useStore((state) => state.push_modal_non_close);
    const api_recalculate = useStore((state) => state.api_recalculate);

  return (<Panel >
            <ViewBase1Form/>
            <Button label={MODAL_CONFIRM_BUTTON_LABEL} onClick={()=>{
                api_recalculate();
                push_modal_non_close(<ModalBase1/>);
            }}/>
         </Panel>)
}